import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable , throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RestUrlsConfig } from '@signature-it/ngx-generic/config';
import { DTPagedData } from '@signature-it/ngx-generic/models';
import { FullJsonDTO } from '@signature-it/ngx-catalogue/models';

@Injectable({
    providedIn: 'root'
})
export class OrdersService {
    protected gpoUrl = `${this.restUrlsConf.appURL}/public/orders/previous.json`;
    protected golUrl = `${this.restUrlsConf.appURL}/public/orders/previous/list.json`;
    protected gPAolUrl = `${this.restUrlsConf.appURL}/orders/pending_approval.json`;
    protected gPAOUUrl = `${this.restUrlsConf.appURL}/orders/pending_approval_users.json`;
    protected gEAoUrl = `${this.restUrlsConf.appURL}/orders/expanded_approve_orders_list.json`;
    protected doUrl = `${this.restUrlsConf.appURL}/orders/delete_order_by_manager.json`;
    protected uqoUrl = `${this.restUrlsConf.appURL}/orders/update_order_qty_by_manager.json`;
    protected apUrl = `${this.restUrlsConf.appURL}/orders/approve_order.json`;
    protected reUrl = `${this.restUrlsConf.appURL}/orders/reject_order.json`;
    protected downloadUrl = `${this.restUrlsConf.appURL}/orders/download_order.json`;
    protected printUrl = `${this.restUrlsConf.appURL}/orders/print_order.json`;
    protected trackingUrl = `${this.restUrlsConf.appURL}/orders/tracking.json`;
    protected uorUrl = `${this.restUrlsConf.appURL}/public/cart/update_order_remarks.json`;
    protected lopUrl = `${this.restUrlsConf.appURL}/orders/last_ordered_products.json`;

    constructor(protected http: HttpClient,
                protected restUrlsConf: RestUrlsConfig) {
    }

    /**
     * @returns Observable<DTPagedData>
     */
    getPreviousOrders(data: any): Observable<DTPagedData<any>> {
        return this.http.post<DTPagedData<any>>(`${this.gpoUrl}`, JSON.stringify(data))
            .pipe(map((res) => new DTPagedData(res)), catchError((error: any) => throwError(error)));
    }

    /**
     * @returns Observable<FullJsonDTO[]>
     */
    getOrdersList(data: string): Observable<FullJsonDTO[]> {
        return this.http.post<FullJsonDTO[]>(this.golUrl, JSON.stringify(data))
            .pipe(map((res) => res), catchError((error: any) => throwError(error)));
    }

    getPendingApprovalOrders(data: any): Observable<DTPagedData<any>> {
        return this.http.post<DTPagedData<any>>(this.gPAolUrl, JSON.stringify(data))
            .pipe(map((res) => new DTPagedData(res)), catchError((error: any) => throwError(error)));
    }

    getPendingApprovalCreators(): Observable<any[]> {
        return this.http.get<any[]>(this.gPAOUUrl)
            .pipe(map((res) => res), catchError((error: any) => throwError(error)));
    }

    getExpandedApproveOrdersList(data: any): Observable<FullJsonDTO[]> {
        return this.http.post<FullJsonDTO[]>(`${this.gEAoUrl}`, JSON.stringify(data))
            .pipe(map((res) => res), catchError((error: any) => throwError(error)));
    }

    deleteOrderByManager(data: any) {
        return this.http.post(this.doUrl, JSON.stringify(data))
            .pipe(map((res) => res), catchError((error: any) => throwError(error)));
    }

    updateOrderQTYByManager(data: any) {
        return this.http.post(this.uqoUrl, JSON.stringify(data))
            .pipe(map((res) => res), catchError((error: any) => throwError(error)));
    }

    approveOrder(data: number) {
        return this.http.post(this.apUrl, JSON.stringify(data))
            .pipe(map((res) => res), catchError((error: any) => throwError(error)));
    }

    rejectOrder(data: number) {
        return this.http.post(this.reUrl, JSON.stringify(data))
            .pipe(map((res) => res), catchError((error: any) => throwError(error)));
    }

    downloadOrder(data: any) {
        return this.http.post(this.downloadUrl, JSON.stringify(data))
            .pipe(map((res) => res), catchError((error: any) => throwError(error)));
    }

    printOrder(data: any) {
        return this.http.post(this.printUrl, JSON.stringify(data))
            .pipe(map((res) => res), catchError((error: any) => throwError(error)));
    }

    getTrackingInfo(orderId: number) {
        return this.http.get(`${this.trackingUrl}/${orderId}`)
            .pipe(map((res) => res), catchError((error: any) => throwError(error)));
    }

    updateOrderRemarks(data: any) {
        return this.http.post(this.uorUrl, JSON.stringify(data), {responseType: 'text'})
            .pipe(map((res) => res), catchError((error: any) => throwError(error)));
    }

    getLastOrderedProducts() {
        return this.http.get<any[]>(this.lopUrl)
            .pipe(map((res) => res), catchError((error: any) => throwError(error)));
    }

}
